export function bytesToMb(bytes) {
  return (bytes/(1024*1024)).toFixed(2);
}

// Taken from https://stackoverflow.com/a/18650828/2540431
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function numberWithCommas(num, options = {}) {
  return num.toLocaleString("en-US", options);
}

export function abbreviateNumber(number) {
  const SI_SYMBOL = ["", "K", "M", "G", "T", "P", "E"];
  const tier = Math.log10(number) / 3 | 0;

  if (tier == 0) return number;

  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);
  const scaled = number / scale;

  return scaled.toFixed(1) + suffix;
}

export function numberToCurrency(number, options = { centsOptional: true }) {
  if (typeof number === "string") {
    number = parseFloat(number);
  }

  let value = number.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  if (options.centsOptional && value.split(".")[1] == "00") {
    value = value.split(".")[0];
  }

  return (options.currencySign === undefined ? '$' : options.currencySign) + value;
}
